import React from "react";
import { motion } from "framer-motion";
import { Lock } from "lucide-react";

export const PACKS = [
    { key: "cinematic",  label: "Cinematic",  hint: "Aurora / Ember / Midnight", premium: false },
    { key: "vintage",    label: "Vintage",    hint: "Sepia film grain",          premium: false },
    { key: "brutalist",  label: "Brutalist",  hint: "Raw concrete & ink",        premium: false },
    { key: "minimal",    label: "Minimal",    hint: "Quiet & spacious",          premium: false },
    { key: "polaroid",   label: "Polaroid",   hint: "Sun-bleached paper",        premium: false },
    { key: "watercolor", label: "Watercolor", hint: "Soft washes",               premium: false },
    // ----- Premium material packs -----
    { key: "cosmic",     label: "Cosmic",     hint: "Holographic & iridescent",  premium: true, swatchClass: "mc-pack-swatch-cosmic" },
    { key: "romantic",   label: "Romantic",   hint: "Vellum & rose-gold",        premium: true, swatchClass: "mc-pack-swatch-romantic" },
    { key: "dark",       label: "Dark",       hint: "Obsidian gloss",            premium: true, swatchClass: "mc-pack-swatch-dark" },
];

export const PREMIUM_PACK_KEYS = new Set(["cosmic", "romantic", "dark"]);

export default function PackSwitcher({ value, onChange, loading, isPremium = false, onPremiumLocked }) {
    return (
        <div className="w-full" data-testid="pack-switcher">
            <div className="flex items-center justify-between mb-3">
                <span className="font-sans text-[10px] uppercase tracking-[0.4em] text-app-3">
                    style pack
                </span>
                {loading && (
                    <span className="font-sans text-[10px] uppercase tracking-[0.3em] text-app-3 animate-pulse">
                        applying…
                    </span>
                )}
            </div>
            <div className="flex gap-2 overflow-x-auto no-scrollbar -mx-6 px-6 pb-2">
                {PACKS.map((p) => {
                    const active = p.key === value;
                    const locked = p.premium && !isPremium;
                    const handleClick = () => {
                        if (loading) return;
                        if (locked) {
                            onPremiumLocked?.(p);
                            return;
                        }
                        onChange(p.key);
                    };
                    return (
                        <motion.button
                            key={p.key}
                            whileTap={{ scale: 0.97 }}
                            onClick={handleClick}
                            data-testid={`pack-${p.key}`}
                            className={`shrink-0 relative px-4 py-2.5 rounded-full border transition-colors flex items-center gap-2 ${
                                active
                                    ? "border-app bg-cta text-app-inverse"
                                    : "border-app/30 bg-surface-2 text-app-2 hover:text-app hover:border-app/60"
                            } ${locked ? "opacity-80" : ""}`}
                        >
                            {p.swatchClass && (
                                <span
                                    aria-hidden="true"
                                    className={`inline-block w-3 h-3 rounded-full border border-white/15 ${p.swatchClass}`}
                                />
                            )}
                            <span className="font-sans text-xs tracking-[0.15em] uppercase">{p.label}</span>
                            {locked && (
                                <Lock className="w-3 h-3 opacity-75" strokeWidth={2} />
                            )}
                        </motion.button>
                    );
                })}
            </div>
        </div>
    );
}
